import { useAppStore } from '@store'
import { Store } from '@types'

type ConfirmationDeleteLateralsProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export default function ConfirmationDeleteLaterals({
  isOpen,
  onClose,
  onConfirm,
}: ConfirmationDeleteLateralsProps) {

  if (!isOpen) return null

  return (
    <div className='dialog white-background z-650 fixed left-1/2 top-1/2 h-min w-72 -translate-x-1/2 -translate-y-1/2 rounded-2xl border-2 border-C/Color3 bg-C/Color1 p-2 text-left text-xs shadow-xl '>
      <div className='flex flex-col items-center justify-center gap-y-1.5'>
        <p className='text-md mt-2 text-center'> {' ¿Quieres eliminar todos los laterales?'}</p>
        <div className='button container mb-2 mt-2 flex w-full justify-center gap-3'>
          <button
            onClick={onConfirm}
            className='flex cursor-pointer items-center rounded-xl bg-C/Color3 px-3 text-xs font-normal text-C/Color1'
          >
            {'Sí'}
          </button>
          <button
            onClick={onClose}
            className='flex cursor-pointer items-center rounded-xl border border-solid border-C/Color7 bg-C/Color5 px-3 py-0.5 text-xs font-normal text-C/Color1'
          >
            {'No'}
          </button>
        </div>
      </div>
    </div>
  )
}
